import cloneDeep from 'lodash/cloneDeep';
import baseModel from './baseModel';

const newModel = cloneDeep(baseModel);
newModel._id = 'new';

export default newModel;
